export default {
  name: "upload-content",
  props: {
    code: {
      type: String,
      default() {
        return "";
      }
    },
    headers: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * 上传的文件字段名
     */
    name: {
      type: String,
      default() {
        return "file";
      }
    },
    action: {
      type: String,
      default() {
        return "";
      }
    },
    defaultFileList: {
      type: Array,
      default() {
        return [];
      }
    },
    fileMaximum: {
      type: Number,
      default() {
        return 1;
      }
    },
    format: {
      type: Array,
      default() {
        return ["jpg", "jpeg", "png"];
      }
    },
    urlAlias: {
      type: String,
      default() {
        return "url";
      }
    },
    callback: {
      type: Function,
      default() {
        return (res, file) => {
          file.mediaId = res.retVal.mediaId;
          file.mediaUrl = res.retVal.mediaUrl;
        };
      }
    }
  },
  data() {
    return {
      uploadList: [],
      isInside: false
    };
  },
  computed: {
    uploadVisible() {
      return this.uploadList.length < this.fileMaximum;
    }
  },
  watch: {
    defaultFileList: {
      immediate: true,
      handler(fileList) {
        console.log(fileList);
        this.$nextTick(() => {
          this.uploadList = this.$refs.upload.fileList;
        });
      }
    }
  },
  methods: {
    clearFiles() {
      console.log(this.$refs["upload"].clearFiles);
      this.uploadList = [];
      this.$refs["upload"].clearFiles();
      this.$emit("on-change", this.code, this.uploadList);
    },
    onSuccess(res, file) {
      if (res.result === 0) {
        this.callback()(res, file);
        this.$emit("on-change", this.code, this.uploadList);
      } else {
        this.$Message.error($t("8j2gel6", "图片上传失败"));
        this.onClickDelete(file);
      }
    },
    onError(res, file, fileList) {
      console.log("失败了res", res);
      console.log("失败了file", file);
      console.log("失败了fileList", fileList);
      this.$Message.error($t("a6dm224", "上传失败"));
    },
    onFormatError(file) {
      this.$Message.error(`${file.name}${$t('96n1wdb', '文件格式不符合，仅允许')}${this.format.join(",")}`);
    },
    onWxceededSize(file) {
      this.$Message.error(`${file.name}${$t('yo51n1f', '文件太大，仅允许5M以下的图片')}`);
    },
    onEnter() {
      this.isInside = true;
    },
    onLeave() {
      this.isInside = false;
    },
    onProgress(event, file, fileList) {
      console.log(event, file, fileList);
    },
    onClickDelete(file) {
      const fileList = this.$refs.upload.fileList;
      this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
      this.$emit("on-change", this.code, this.uploadList);
    },
    onClickExpand(file) {
      const h = this.$createElement;
      // this.$emit("on-preview", file[this.urlAlias]);
      this.$Modal.info({
        title: $t("dllyz34", "查看图片"),
        width: 900,
        closable: true,
        render() {
          const h = arguments[0];
          return h("img", {
            "style": "width:100%",
            "attrs": {
              "src": file.url
            }
          });
        }
      });
    }
  },
  mounted() {
    this.uploadList = this.$refs.upload.fileList;
  }
};